import React from 'react';

function NotFound() {
  return (
    <div>
      <h2>ERRO 404</h2>
      <h1>PÁGINA NÃO ENCONTRADA</h1>
    </div>
  );
}

export default NotFound;
